import React from 'react';
import classnames from 'classnames';
import { T as Typography } from './Typography-BUVIUAC9.js';

var styles = {"inlineLabel":"S72WkdRbhc0-","base":"bMWuAXJHkbw-","large":"ui07veHjPII-","larger":"WIXhLSQ7z8A-","greyBlue":"_8RuKvOhj-Ro-","red":"_2vEF1nvVWm8-","orange":"Wt305sIAeoE-","green":"F8KkNxz8W3A-","success":"LJQb00ufiyQ-","blue":"URZZoKSX4So-","inactive":"c6sFmqajaYE-","navy":"OeLBV-9i0Rs-","task":"BAQHvQZjbyA-","yellow":"_2Xwx5tarf1w-","warning":"VYi1KJGzm9U-","lime":"iCqIjI7GkEk-","purple":"_4iEIjiZj9oA-","invoice":"vS3TEIwvOts-","pink":"JRW9QFSjLTA-","quote":"D8txxeUYzFs-","teal":"fbhprd-Gl8k-","yellowGreen":"yrF9aZSaTdw-","job":"vn6HwAFptJ4-","blueDark":"RPvjah0FdjI-","lightBlue":"apwauWJ6ITc-","informative":"CcbIpjwK7jU-","indigo":"n8qJynvE-n0-","request":"Y-cTpwjcfOA-"};

function InlineLabel({ size = "base", color = "greyBlue", children, }) {
    const className = classnames(styles.inlineLabel, styles[size], styles[color]);
    const sizeMapper = {
        base: "small",
        large: "large",
        larger: "large",
    };
    return (React.createElement("span", { className: className },
        React.createElement(Typography, { element: "span", size: sizeMapper[size] }, children)));
}

export { InlineLabel as I };
